// extracted by css-extract-rspack-plugin
export default {"card":"TQ4Ij"};